import { createSelectVisibleColumns } from "ds/components/Table/useTableStore/selectors";

import { CONTEXTS_COLUMN_CONFIG } from "../../../constants";

export const selectVisibleColumns = createSelectVisibleColumns(CONTEXTS_COLUMN_CONFIG);
